import { useMediaQuery } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import type { SxProps, Theme } from '@mui/material/styles';

import Selector from 'shared/atoms/Selector';
import type { BackgroundThemes } from 'shared/const';
import theme from 'shared/themes/default';

import FormLabel from '../components/FormLabel';
import type { FormFieldProperties } from '../FormInput';

interface SelectorOption {
  key: string;
  value: string;
}

interface FormSelectorProps {
  disabled?: boolean;
  handleChange?: (params: { name: string; value: unknown }) => void;
  id: string;
  infoText?: string;
  label: string;
  name: string;
  options: SelectorOption[];
  properties?: Record<string, FormFieldProperties>;
  required?: boolean;
  sx?: SxProps<Theme>;
  theme?: BackgroundThemes;
  values?: Record<string, unknown>;
}

const FormSelector = ({
  disabled: disabledProp,
  handleChange,
  id,
  infoText,
  label,
  name,
  options,
  properties = {},
  required: requiredProp,
  sx = {},
  theme: themeLayout = 'dark',
  values = {},
}: FormSelectorProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.mobile);
  const { disabled, required } = properties[name] || {};

  const sxFormControl: SxProps<Theme> = {
    width: isMobile ? '100%' : 'auto',
  };

  const onChangeHandler = (value: string) => {
    handleChange?.({ name, value });
  };

  return (
    <FormControl
      disabled={disabledProp === undefined ? disabled : disabledProp}
      fullWidth
      required={requiredProp === undefined ? required : requiredProp}
      sx={[sxFormControl, sx] as SxProps<Theme>}
    >
      <FormLabel
        id={id}
        infoText={infoText}
        label={label}
        theme={themeLayout}
      />
      <div>
        <Selector
          value={values[name] as string}
          disabled={disabledProp}
          onChange={onChangeHandler}
          options={options}
        />
      </div>
    </FormControl>
  );
};

export default FormSelector;
export type { FormSelectorProps, SelectorOption };
